import { render, staticRenderFns } from "./activeSuccess.vue?vue&type=template&id=2fc37f3e&scoped=true"
import script from "./activeSuccess.vue?vue&type=script&lang=js"
export * from "./activeSuccess.vue?vue&type=script&lang=js"
import style0 from "./activeSuccess.vue?vue&type=style&index=0&id=2fc37f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc37f3e",
  null
  
)

export default component.exports